module.exports = __webpack_public_path__ + "fonts/KaTeX_Fraktur-Regular.e435cda5.woff";